export const PROPERTY_TYPES = [
  { value: 'single-family-detached', label: 'Single Family' },
  { value: 'condominium', label: 'Condominium' },
  { value: 'townhouse', label: 'Townhouse' },
  { value: '2-4-unit', label: '2-4 Unit Apartment' },
  { value: 'other', label: 'Other' },
]

export const PROPERTY_USAGES = [
  { value: 'principal-residence', label: 'Principal Residence' },
  { value: 'second-home', label: 'Second Home' },
  { value: 'investment', label: 'Investment' },
]

export const FICO_RANGES = [
  { value: '499', label: 'Under 500' },
  { value: '548', label: '500 - 549' },
  { value: '598', label: '550 - 599' },
  { value: '618', label: '600 - 619' },
  { value: '699', label: '620 - 700' },
  { value: '701', label: 'Over 700' },
]

export const US_STATES = [
  { value: 'AK', label: 'Alaska' },
  { value: 'AL', label: 'Alabama' },
  { value: 'AR', label: 'Arkansas' },
  { value: 'AS', label: 'American Samoa' },
  { value: 'AZ', label: 'Arizona' },
  { value: 'CA', label: 'California' },
  { value: 'CM', label: 'Northern Mariana Islands' },
  { value: 'CO', label: 'Colorado' },
  { value: 'CT', label: 'Connecticut' },
  { value: 'DC', label: 'District of Columbia' },
  { value: 'DE', label: 'Delaware' },
  { value: 'FL', label: 'Florida' },
  { value: 'GA', label: 'Georgia' },
  { value: 'GU', label: 'Guam' },
  { value: 'HI', label: 'Hawaii' },
  { value: 'IA', label: 'Iowa' },
  { value: 'ID', label: 'Idaho' },
  { value: 'IL', label: 'Illinois' },
  { value: 'IN', label: 'Indiana' },
  { value: 'KS', label: 'Kansas' },
  { value: 'KY', label: 'Kentucky' },
  { value: 'LA', label: 'Louisiana' },
  { value: 'MA', label: 'Massachusetts' },
  { value: 'MD', label: 'Maryland' },
  { value: 'ME', label: 'Maine' },
  { value: 'MI', label: 'Michigan' },
  { value: 'MN', label: 'Minnesota' },
  { value: 'MO', label: 'Missouri' },
  { value: 'MS', label: 'Mississippi' },
  { value: 'MT', label: 'Montana' },
  { value: 'NC', label: 'North Carolina' },
  { value: 'ND', label: 'North Dakota' },
  { value: 'NE', label: 'Nebraska' },
  { value: 'NH', label: 'New Hampshire' },
  { value: 'NJ', label: 'New Jersey' },
  { value: 'NM', label: 'New Mexico' },
  { value: 'NV', label: 'Nevada' },
  { value: 'NY', label: 'New York' },
  { value: 'OH', label: 'Ohio' },
  { value: 'OK', label: 'Oklahoma' },
  { value: 'OR', label: 'Oregon' },
  { value: 'PA', label: 'Pennsylvania' },
  { value: 'PR', label: 'Puerto Rico' },
  { value: 'RI', label: 'Rhode Island' },
  { value: 'SC', label: 'South Carolina' },
  { value: 'SD', label: 'South Dakota' },
  { value: 'TN', label: 'Tennessee' },
  { value: 'TT', label: 'Trust Territory of the Pacific Islands' },
  { value: 'TX', label: 'Texas' },
  { value: 'UT', label: 'Utah' },
  { value: 'VA', label: 'Virginia' },
  { value: 'VI', label: 'Virgin Islands' },
  { value: 'VT', label: 'Vermont' },
  { value: 'WA', label: 'Washington' },
  { value: 'WI', label: 'Wisconsin' },
  { value: 'WV', label: 'West Virginia' },
  { value: 'WY', label: 'Wyoming' },
]

export enum OFFER_ERROR_MESSAGES {
  FICO_TOO_LOW = 'fico_too_low',
  FICO_TOO_LOW__FOR_ER_CALCULATION = 'fico_too_low_for_er_calculation',
  EQUITY_TOO_LOW = 'minimum_investment_guideline_reached',
  HOME_VALUE_TOO_HIGH = 'Home value is too high',
  REMAINING_FUNDING_LIMIT_EXCEEDED = 'remaining_funding_limit_exceeded',
  SUB_550_CONDITIONS_NOT_MET = 'sub_550_conditions_not_met',
}
